import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../Assets/Logos/logo.jpg";
import { FaUserCircle, FaSignOutAlt } from "react-icons/fa";
import { PiUserCircleDuotone } from "react-icons/pi";
import { RiMenu4Line } from "react-icons/ri";
import { IoClose } from "react-icons/io5";
import "./AuthNavbar.css";
import Swal from "sweetalert2";

const AuthNavbar = ({ setIsSidebarOpen, isSidebarOpen }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You'll be logged out of your admin account.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, logout",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: "Logged out!",
          text: "Redirecting to login...",
          timer: 2000,
          showConfirmButton: false,
        });

        setTimeout(() => {
          localStorage.removeItem("token");
          localStorage.removeItem("admin-data");
          window.location.href = "/admin-login";
        }, 2000);
      }
    });
  };

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const handleHamburgerClick = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <React.Fragment>
      <nav className="bg-white  shadow-sm border-b border-gray-200 fixed top-0 w-full z-50 h-16">
        <div className="h-full px-4 flex justify-between items-center">
          {/* Left side - Hamburger + Logo */}
          <div className="flex items-center space-x-4">
            <button
              onClick={handleHamburgerClick}
              className="lg:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors duration-200"
            >
              {isSidebarOpen ? (
                <IoClose size={24} />
              ) : (
                <RiMenu4Line size={24} />
              )}
            </button>

            <div className="flex overflow-hidden items-center pl-4">
              <img
                src={logo}
                alt="Logo"
                className="h-16 scale-110 w-auto cursor-pointer"
              />
            </div>
          </div>

          {/* Right side - User menu */}
          <div className="flex items-center relative" ref={dropdownRef}>
            <button
              onClick={toggleDropdown}
              className="flex items-center space-x-2 p-2 rounded-lg hover:bg-gray-50 transition-colors duration-200"
            >
              <div className="relative">
                <svg width="0" height="0">
                  <linearGradient
                    id="icon-gradient"
                    x1="100%"
                    y1="0%"
                    x2="0%"
                    y2="100%"
                  >
                    <stop
                      stopColor="currentColor"
                      className="text-primaryColor"
                      offset="0%"
                    />
                    <stop
                      stopColor="currentColor"
                      className="text-primaryTextColor"
                      offset="100%"
                    />
                  </linearGradient>
                </svg>
                <PiUserCircleDuotone
                  size={40}
                  style={{
                    fill: "url(#icon-gradient)",
                  }}
                />
              </div>

              <svg
                className={`w-4 h-4 text-gray-600 transform transition-transform duration-200 ${
                  isDropdownOpen ? "rotate-180" : ""
                }`}
                fill="none"
                viewBox="0 0 10 6"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 4 4 4-4"
                />
              </svg>
            </button>

            {/* Dropdown menu */}
            {isDropdownOpen && (
              <div className="absolute right-0 top-full mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-[99999]">
                <Link
                  to="/admin-profile"
                  onClick={toggleDropdown}
                  className="w-full text-left flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-200"
                >
                  <FaUserCircle className="mr-3 text-gray-500" size={16} />
                  Profile
                </Link>
                <button
                  onClick={() => {
                    handleLogout();
                    toggleDropdown();
                  }}
                  className="w-full text-left flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-200"
                >
                  <FaSignOutAlt className="mr-3 text-gray-500" size={16} />
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </nav>
    </React.Fragment>
  );
};

export default AuthNavbar;
